import React, { createContext, useState, useEffect, useContext } from "react";
import { BASE_URL } from "./Base_Url";

// 1. Create Context
export const GlobalContext = createContext();

// 2. Create Provider
export function GlobalProvider({ children }) {
    const [segments, setSegments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [contactData, setContactData] = useState(null);
    // Fetch data from API
    const fetchSegments = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${BASE_URL}/segment/`);
            if (!response.ok) {
                throw new Error("Failed to fetch segments");
            }
            const data = await response.json();
            setSegments(data?.data || []); // assuming your API returns { message, data: [...] }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetch(`${BASE_URL}/contactus/`)
            .then((res) => res.json())
            .then((data) => {
                if (data?.data?.length > 0) {
                    setContactData(data.data[0]); // take the first record
                }
            })
            .catch((err) => {
                console.error("Error fetching contact data:", err);
            });
    }, []);

    console.log("contactData", contactData)


    // Load on mount
    useEffect(() => {
        fetchSegments();
    }, []);

    return (
        <GlobalContext.Provider value={{ segments, loading, error, fetchSegments, contactData }}>
            {children}
        </GlobalContext.Provider>
    );
}

export function useGlobalContext() {
    return useContext(GlobalContext);
}